import { Menu, Layout, Avatar, Button, Row, Divider } from "antd";
import "./Sidebar.css"
import { IconMenuSettingList } from "../../assets/icons/icons";

import { RiUserSettingsLine } from "react-icons/ri";
import { FiDatabase } from "react-icons/fi";
import { useEffect, useState } from "react";
import { SIDEBAR_CONSTANT } from "../../constant/sidebar.constant";
import { useNavigate, useLocation } from "react-router-dom";
import Dashboard from "../dashboard/Dashboard";
import { ACCOUNT_LIST_CONSTANT } from "../../constant/accountlist.constant";
import { RESOURCE_LIST_CONSTANT } from "../../constant/resourcelist.constant";
import { ROUTER_CONSTANT } from "../../constant/router.constant";

const Sidebar = () => {
  const { Sider } = Layout;
  const [selectedMenu, setSelectedMenu] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const pathlocation = location.pathname.split("/");

  const accountListMenu = SIDEBAR_CONSTANT.MENU_ACCOUNT_LIST;
  const dashboardMenu = SIDEBAR_CONSTANT.MENU_DASHBOARD

  const handleClickSidebarLevelOne = (selectMenu) => {
    setSelectedMenu(selectMenu);
  }

  const displaySidebarLevelTwo = () => {
    switch (selectedMenu) {
      case accountListMenu: return menuAccountList();
      case dashboardMenu: return <Dashboard />
      default: return menuAccountList();
    }
  }

  const menuAccountList = () => {
    return (
      <>
        <Menu mode="inline" className="sidebar-level-two-menu-style" defaultSelectedKeys={[pathlocation[pathlocation.length - 1]]}>
          <Menu.Item key="account-list">
            <Button
              shape="round"
              className="sidebar-level-two-button-style"
              onClick={() => navigate(`${ROUTER_CONSTANT.HOME}${ROUTER_CONSTANT.ACCOUNT_LIST}`)}
              icon={
                <Avatar
                  className="sidebar-icon-level-two-style"
                  icon={<RiUserSettingsLine />}
                />
              }>
              <span> {ACCOUNT_LIST_CONSTANT.MENU_USER_ACCOUNT_LIST} </span>
            </Button>
          </Menu.Item>
          <Menu.Item key="resource-list">
            <Button
              className="sidebar-level-two-button-style"
              shape="round"
              onClick={() => navigate(`${ROUTER_CONSTANT.HOME}${ROUTER_CONSTANT.RESOURCE_LIST}`)}
              icon={
                <Avatar
                  icon={<FiDatabase />}
                  className="sidebar-icon-level-two-style"
                />
              }>
              <span> {RESOURCE_LIST_CONSTANT.MENU_RESOURCE_LIST} </span>
            </Button>
          </Menu.Item>
        </Menu>
      </>
    )
  }

  useEffect(() => {
    let defaultMenu = accountListMenu;
    setSelectedMenu(defaultMenu);
  }, [accountListMenu]);

  return (
    <>
      <Sider width={75} className="sidebar-level-one-style">
        <Button
          onClick={() => handleClickSidebarLevelOne(accountListMenu)}
          className="button-sidebar-level-one"
        >
          <Avatar
            className="avatar-sidebar-level-one"
            icon={<IconMenuSettingList style={{ color: "dodgerblue", fontSize: "25px" }} />}
          />
        </Button>
      </Sider>

      <Sider width={250} className="sidebar-level-two-style">
        <div className="sidebar-level-two-content-style">
          <Row>
            <span className="sidebar-level-two-title">Setting List</span>
          </Row>

          <Divider className="sidebar-divider" />

          <Row>
            {displaySidebarLevelTwo()}
          </Row>
        </div>
      </Sider>
    </>
  )
}

export default Sidebar;